import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as me from '../../feature'

import { getActionsConfig } from './actions'
import { Api } from './api.service'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Loads sibling users assigned to the current portal context for sharing.
 */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(parent: me.Feature) {
    const api = new Api(parent)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'SiblingUsers',
      parent,
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.clearOnContextChange(parent),
      effects.startGet(parent),
      effects.executeGet(api),
    )
  }
}
